function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface130148419"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.588236%,29.803923%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 24 4 C 12.941406 4 4 12.941406 4 24 C 4 35.058594 12.941406 44 24 44 C 35.058594 44 44 35.058594 44 24 C 44 12.941406 35.058594 4 24 4 Z M 34 31.179688 L 31.179688 34 L 24 26.820312 L 16.820312 34 L 14 31.179688 L 21.179688 24 L 14 16.820312 L 16.820312 14 L 24 21.179688 L 31.179688 14 L 34 16.820312 L 26.820312 24 Z M 34 31.179688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongIcon);
export default __webpack_public_path__ + "static/media/wrong-icon.62ee6dd4da28317ea817044af144d65a.svg";
export { ForwardRef as ReactComponent };